export default "__VITE_ASSET__BBQdGrqR__"